/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationCrossPlayHandlersQuestProgressDto
 */
export interface FxIdApplicationCrossPlayHandlersQuestProgressDto {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationCrossPlayHandlersQuestProgressDto
     */
    IsFinished: boolean;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationCrossPlayHandlersQuestProgressDto
     */
    CurrentValue: number;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationCrossPlayHandlersQuestProgressDto
     */
    CumulativeValue: number;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationCrossPlayHandlersQuestProgressDto
     */
    CountValue: number;
}

/**
 * Check if a given object implements the FxIdApplicationCrossPlayHandlersQuestProgressDto interface.
 */
export function instanceOfFxIdApplicationCrossPlayHandlersQuestProgressDto(value: object): value is FxIdApplicationCrossPlayHandlersQuestProgressDto {
    if (!('IsFinished' in value) || value['IsFinished'] === undefined) return false;
    if (!('CurrentValue' in value) || value['CurrentValue'] === undefined) return false;
    if (!('CumulativeValue' in value) || value['CumulativeValue'] === undefined) return false;
    if (!('CountValue' in value) || value['CountValue'] === undefined) return false;
    return true;
}

export function FxIdApplicationCrossPlayHandlersQuestProgressDtoFromJSON(json: any): FxIdApplicationCrossPlayHandlersQuestProgressDto {
    return FxIdApplicationCrossPlayHandlersQuestProgressDtoFromJSONTyped(json, false);
}

export function FxIdApplicationCrossPlayHandlersQuestProgressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationCrossPlayHandlersQuestProgressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'IsFinished': json['IsFinished'],
        'CurrentValue': json['CurrentValue'],
        'CumulativeValue': json['CumulativeValue'],
        'CountValue': json['CountValue'],
    };
}

export function FxIdApplicationCrossPlayHandlersQuestProgressDtoToJSON(json: any): FxIdApplicationCrossPlayHandlersQuestProgressDto {
    return FxIdApplicationCrossPlayHandlersQuestProgressDtoToJSONTyped(json, false);
}

export function FxIdApplicationCrossPlayHandlersQuestProgressDtoToJSONTyped(value?: FxIdApplicationCrossPlayHandlersQuestProgressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'IsFinished': value['IsFinished'],
        'CurrentValue': value['CurrentValue'],
        'CumulativeValue': value['CumulativeValue'],
        'CountValue': value['CountValue'],
    };
}

